import { createSlice } from '@reduxjs/toolkit';

export const payrollSlice = createSlice({
  name: 'payroll',
  initialState: {
    loading: false,
    error: null,
    grids: [
      {
        id: 'payslips',
        metaData: {
          filters: [],
          sorting: {},
          pagination: {
            page: 1,
            current: 1,
            pageSize: 10,
            total: 0,
            defaultCurrent: 1,
            showSizeChanger: true,
            pageSizeOptions: [10, 50, 100],
          },
          visibleColumns: [],
          exportColumns: [],
        },
      },
      {
        id: 'payments',
        metaData: {
          filters: [],
          sorting: {},
          pagination: {
            page: 1,
            current: 1,
            pageSize: 5,
            total: 0,
            defaultCurrent: 1,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 50, 100],
          },
          visibleColumns: [],
          exportColumns: [],
        },
      },
    ],
    gridTabs: [],
    activeTabIndex: null,
    lastRefreshedPayslipId: null,
  },
  reducers: {
    updateTableMetaData: (state, { payload }) => {
      state.metaData = payload.metaData;
    },
    updateGridMetaData: (state, { payload: { metaData, gridId } }) => {
      const gridIndex = state.grids.findIndex((grid) => grid.id === gridId);
      state.grids[gridIndex].metaData = {
        ...state.grids[gridIndex].metaData,
        ...metaData,
      };
    },
    resetFilters: (state) => {
      state.metaData = {
        ...state.metaData,
        filters: [],
      };
    },
    resetGridFilters: (state, { payload: { gridId } }) => {
      const gridIndex = state.grids.findIndex((grid) => grid.id === gridId);
      state.grids[gridIndex].metaData.filters = [];
    },
    addOrGotoPayslipTab: (state, { payload }) => {
      const { tab: newTab = {} } = payload;
      const tabFound = state.gridTabs.find((tab) => tab.key === newTab.key);

      if (!tabFound) {
        state.gridTabs = state.gridTabs.concat(newTab);
        state.activeTabIndex = newTab.key;
      } else {
        state.activeTabIndex = newTab.key;
      }
    },
    gotoPayslipTab: (state, { payload }) => {
      const { key } = payload;
      state.activeTabIndex = key;
    },
    removePayslipTab: (state, { payload }) => {
      const { key } = payload;
      const foundIndex = state.gridTabs.findIndex((tab) => tab.key === key);
      if (foundIndex >= 0) {
        state.gridTabs = state.gridTabs.filter((tab) => tab.key !== key);
        state.activeTabIndex = 'payslips';
      }
    },
    addNewPayslipTab: (state, { payload }) => {
      const { tab: newTab = {} } = payload;
      console.log('%%%%%%%%%%%%% addNewPayslipTab', newTab);
      state.gridTabs = state.gridTabs.concat(newTab);
      state.activeTabIndex = newTab.key;
    },
    newPayslipAdded: (state, { payload: { payslip } }) => {
      state.lastRefreshedPayslipId = payslip.id;
    },
    updateVisibleColumns: (state, { payload: { gridId, visibleColumns } }) => {
      const gridIndex = state.grids.findIndex((grid) => grid.id === gridId);
      state.grids[gridIndex].metaData.visibleColumns = visibleColumns;
      state.grids[gridIndex].metaData.exportColumns = visibleColumns;
    },
    updateExportColumns: (state, { payload: { gridId, exportColumns } }) => {
      const gridIndex = state.grids.findIndex((grid) => grid.id === gridId);
      state.grids[gridIndex].metaData.exportColumns = exportColumns;
    },
  },
});

export const {
  updateTableMetaData,
  updateGridMetaData,
  resetFilters,
  resetGridFilters,
  addOrGotoPayslipTab,
  gotoPayslipTab,
  removePayslipTab,
  addNewPayslipTab,
  newPayslipAdded,
  updateVisibleColumns,
  updateExportColumns,
} = payrollSlice.actions;

export default payrollSlice.reducer;
